var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iconUrl)?_c('div',{staticClass:"ui-label-prestige-icon",style:({backgroundImage: ("url(" + _vm.iconUrl + ")")})}):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e6b57fa","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/ui/label/prestige-icon.vue
// module id = 552
// module chunks = 0 1 2 3